/**
 * @generated SignedSource<<407931a88455ba4c0628fa542227e3a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionViewToolbar_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useDibsSetApprovalForAll_viewer">;
  readonly " $fragmentType": "NftProfileImportCollectionViewToolbar_viewer";
};
export type NftProfileImportCollectionViewToolbar_viewer$key = {
  readonly " $data"?: NftProfileImportCollectionViewToolbar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewToolbar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionViewToolbar_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDibsSetApprovalForAll_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b7d8a81bb8610724dc9afd8eaa086754";

export default node;
